import { GET_MARKER_MEETINGS, GET_CENTRAL_MARKER_MEETINGS, REPORT_ERROR, GET_ALL_MEETING_YEARS } from '../Actions/Reports.Actions';

const initState = {
	markerMeetings: [],
    centralMarkerMeetings: [],
    allMeetingYears: [],
	apiCallCompleted: false,
	errorMessage: ''
};

const reports = (state = initState, action) => {
	let updated = {};
    switch (action.type) {
        case GET_ALL_MEETING_YEARS:
            updated = {
                ...state,
                allMeetingYears: action.payload.data,
                apiCallCompleted: true,
                errorMessage: action.payload.data.errors
            };
            break;
		case GET_MARKER_MEETINGS:
			updated = {
				...state,
				markerMeetings: action.payload.data,
				apiCallCompleted: true,
				errorMessage: action.payload.data.errors
			};
			break;
		case GET_CENTRAL_MARKER_MEETINGS:
			updated = {
				...state,
				centralMarkerMeetings: action.payload.data,
				apiCallCompleted: true,
				errorMessage: action.payload.data.errors
			};
			break;
		case REPORT_ERROR:
			updated = {
				...state,
				errorMessage: action.payload.errorMessage,
				apiCallCompleted: true
			};
			break;
		default:
			return state;
    }
	return updated;
};

export default reports;
